import React, { Component } from "react";
import Time from "react-time-format";
import { connect } from "react-redux";
import { change_Lang } from "../../../actions/Helper_action";
import { FaMapMarkerAlt, FaPhoneAlt } from "react-icons/fa";
class PrintAsaysh extends Component {
 render() {
  const { lang, change_Lang, create_asaysh, logo, primary_logo, footer_logo } =
   this.props;
  return (
   <>
    <div class={`${lang === "en" ? "" : " fk"}`}>
     <div class="row content-containers" id="tbls_support">
      <div class="col-12  ">
       <img
        src={primary_logo}
        alt="logo"
        className="img-fluid img-responsive"
        style={{ position: "relative", top: 0, width: "100%" }}
       />
      </div>
     </div>
     <div class="row mt-2">
      <div class="col-12">
       <div class="row">
        <div class="col-12 d-flex justify-content-center">
         <p
          style={{
           fontSize: "24px",
           color: "#000",
           fontWeight: "bolder",
          }}
          class={`d-flex justify-content-center text-uppercase ${
           lang !== "en" ? "fk" : "fkp"
          } `}
         >
          ئەنکێتی زانیاری
         </p>
        </div>
       </div>
       <div class="row">
        <div class="col-12">
         <div class="form-group row form-inline">
          <label
           style={{
            fontSize: "22px",
            color: "black",
            fontWeight: "bold",
           }}
           class="col-sm-3 col-form-label fkk"
          >
           بۆ ئاسایشی:
          </label>
          <div class="col-sm-3">
           <label
            class="d-flex justify-content-start"
            style={{ fontWeight: "bold", fontSize: "18px" }}
           >
            {create_asaysh.scuertyName}
           </label>
          </div>

          <label
           style={{
            fontSize: "22px",
            color: "black",
            fontWeight: "bold",
           }}
           class="col-sm-3 col-form-label fkk"
          >
           جۆری موڵک:
          </label>
          <div class="col-sm-3">
           <label
            class="d-flex justify-content-start text-center"
            style={{ fontWeight: "bold", fontSize: "16px" }}
           >
            {change_Lang(create_asaysh.property_type)}
           </label>
          </div>

          <label
           style={{
            fontSize: "22px",
            color: "black",
            fontWeight: "bold",
           }}
           class="col-sm-3 fkk col-form-label"
          >
           ڕێکەوت:
          </label>
          <div class="col-sm-3">
           <label
            class="d-flex justify-content-start"
            style={{ fontWeight: "bold", fontSize: "18px" }}
           >
            <Time
             value={create_asaysh.createdAt}
             format="YYYY-MM-DD"
             style={{ color: "black" }}
             className={`${lang === "en" ? "" : "fk"}`}
            />
           </label>
          </div>
          <label
           style={{
            fontSize: "22px",
            color: "black",
            fontWeight: "bold",
           }}
           class="col-sm-3 fkk col-form-label"
          >
           {" "}
           لقی عقارات:
          </label>
          <div class="col-sm-3">
           <label
            class="d-flex justify-content-start"
            style={{ fontWeight: "bold", fontSize: "18px" }}
           >
            {create_asaysh.branchId && create_asaysh.branchId.name}
           </label>
          </div>
         </div>
        </div>
       </div>
       <div class="row mt-3">
        <div class="col-12 d-flex justify-content-start ">
         <label
          class="d-flex justify-content-start"
          style={{
           fontWeight: "bold",
           fontSize: "20px",
           textAlign: "justify",
          }}
         >
          بە نیازین ئەم ({change_Lang(create_asaysh.property_type)}) یە بەکرێ
          بدەین لە ({create_asaysh.ownerSeating}) بۆ ئەم بەڕێزەی کە لە خوارەوە
          ناوی هاتووە، داواکارین لە بەڕێزتان کە ڕەزامەندی بفەرموون هاوکاریتان
          جێگەی پێزانینە.
         </label>
        </div>
       </div>

       <div class="row">
        <div class="col-12">
         <hr
          style={{
           height: "2px",
           backgroundColor: `#000`,
          }}
         />
         {/* title */}
         <div className="row">
          <div className="col-12 d-flex justify-content-center">
           <h3 style={{ fontWeight: "bold" }}>زانیاری کرێچی ئێستا</h3>
          </div>
         </div>
         <div class="form-group row form-inline">
          <label
           style={{
            fontSize: "20px",
            color: "#000",
            fontWeight: "bold",
           }}
           class="col-sm-3 col-form-label"
          >
           {change_Lang("The name of the tenant")}:
          </label>
          <div
           class="col-sm-3 d-flex justify-content-start"
           style={{
            fontSize: "20px",
            color: "#000",
            fontWeight: "bold",
           }}
          >
           {create_asaysh.tenantname}
          </div>
          <label
           style={{
            fontSize: "20px",
            color: "#000",
            fontWeight: "bold",
           }}
           class="col-sm-3 col-form-label"
          >
           {change_Lang("where they came")}:
          </label>
          <div
           class="col-sm-2 d-flex justify-content-start"
           style={{
            fontSize: "20px",
            color: "#000",
            fontWeight: "bold",
           }}
          >
           {create_asaysh.tenantadress}
          </div>
         </div>
         {/* second */}
         <div class="form-group row form-inline">
          <label
           style={{
            fontSize: "20px",
            color: "#000",
            fontWeight: "bold",
           }}
           class="col-sm-3 col-form-label"
          >
           {" "}
           {change_Lang("invoice_mob")}:
          </label>
          <div
           class="col-sm-3 d-flex justify-content-start"
           style={{ fontSize: "20px", fontWeight: "bold" }}
          >
           {create_asaysh.tenantphone}
          </div>
          <label
           style={{
            fontSize: "20px",
            color: "#000",
            fontWeight: "bold",
           }}
           class="col-sm-3 col-form-label"
          >
           نەتەوە - ڕەگەزنامە:
          </label>
          <div
           class="col-sm-3 d-flex justify-content-start"
           style={{ fontSize: "20px", fontWeight: "bold" }}
          >
           {create_asaysh.tenant_nationality}
          </div>
         </div>
         {/* third */}
         <div class="form-group row form-inline">
          <label
           style={{
            fontSize: "20px",
            color: "#000",
            fontWeight: "bold",
           }}
           class="col-sm-3 col-form-label"
          >
           ژمارەی ئەندامەکانی خێزان:
          </label>
          <div
           class="col-sm-3 d-flex justify-content-start"
           style={{ fontSize: "20px", fontWeight: "bold" }}
          >
           {create_asaysh.familynumber}
          </div>
          <label
           style={{
            fontSize: "20px",
            color: "#000",
            fontWeight: "bold",
           }}
           class="col-sm-3 col-form-label"
          >
           {/* ژمارەی ئەندامەکانی خێزان: */}
          </label>
          <div
           class="col-sm-3 d-flex justify-content-start"
           style={{ fontSize: "20px", fontWeight: "bold" }}
          >
           {/* {create_asaysh.familynumber} */}
          </div>
         </div>
         <hr
          style={{
           height: "2px",
           backgroundColor: `#000`,
          }}
         />
         {/* title */}
         <div className="row">
          <div className="col-12 d-flex justify-content-center">
           <h3 style={{ fontWeight: "bold" }}>زانیاری کرێچی پێشوو</h3>
          </div>
         </div>
         <div class="form-group row form-inline">
          <label
           style={{
            fontSize: "20px",
            color: "#000",
            fontWeight: "bold",
           }}
           class="col-sm-3 col-form-label"
          >
           {change_Lang("Former tenant's name")}:
          </label>
          <div
           class="col-sm-3 d-flex justify-content-start"
           style={{
            fontSize: "20px",
            color: "#000",
            fontWeight: "bold",
           }}
          >
           {create_asaysh.oldtenantname}
          </div>
          <label
           style={{
            fontSize: "20px",
            color: "#000",
            fontWeight: "bold",
           }}
           class="col-sm-3 col-form-label"
          >
           {change_Lang("Where to go")}:
          </label>
          <div
           class="col-sm-2 d-flex justify-content-start"
           style={{
            fontSize: "20px",
            color: "#000",
            fontWeight: "bold",
           }}
          >
           {create_asaysh.oldtenantadress}
          </div>
         </div>
         {/* second */}
         <div class="form-group row form-inline">
          <label
           style={{
            fontSize: "20px",
            color: "#000",
            fontWeight: "bold",
           }}
           class="col-sm-3 col-form-label"
          >
           {" "}
           {change_Lang("invoice_mob")}:
          </label>
          <div
           class="col-sm-3 d-flex justify-content-start"
           style={{ fontSize: "20px", fontWeight: "bold" }}
          >
           {create_asaysh.oldtenantphone}
          </div>
          <label
           style={{
            fontSize: "20px",
            color: "#000",
            fontWeight: "bold",
           }}
           class="col-sm-3 col-form-label"
          >
           نەتەوە - ڕەگەزنامە:
          </label>
          <div
           class="col-sm-3 d-flex justify-content-start"
           style={{ fontSize: "20px", fontWeight: "bold" }}
          >
           {create_asaysh.oldtenant_nationality}
          </div>
         </div>
         <hr
          style={{
           height: "2px",
           backgroundColor: `#000`,
          }}
         />
         <div className="row">
          <div className="col-12 d-flex justify-content-center">
           <h3 style={{ fontWeight: "bold" }}>زانیاری خاوەن موڵك</h3>
          </div>
         </div>
         <div class="form-group row form-inline">
          <label
           style={{
            fontSize: "20px",
            color: "#000",
            fontWeight: "bold",
           }}
           class="col-sm-3 col-form-label"
          >
           ناوی خاوەن موڵك:
          </label>
          <div
           class="col-sm-3 d-flex justify-content-start"
           style={{
            fontSize: "20px",
            color: "#000",
            fontWeight: "bold",
           }}
          >
           {create_asaysh.ownername}
          </div>
          <label
           style={{
            fontSize: "20px",
            color: "#000",
            fontWeight: "bold",
           }}
           class="col-sm-3 col-form-label"
          >
           ژمارەی مۆبایلی خاوەن موڵك:
          </label>
          <div
           class="col-sm-2 d-flex justify-content-start"
           style={{
            fontSize: "20px",
            color: "#000",
            fontWeight: "bold",
           }}
          >
           {create_asaysh.ownerPhone}
          </div>
         </div>
         {/* second */}
         <div class="form-group row form-inline">
          <label
           style={{
            fontSize: "20px",
            color: "#000",
            fontWeight: "bold",
           }}
           class="col-sm-3 col-form-label"
          >
           ناونیشانی موڵك:
          </label>
          <div
           class="col-sm-3 d-flex justify-content-start"
           style={{ fontSize: "20px", fontWeight: "bold" }}
          >
           {create_asaysh.ownerSeating}
          </div>
          <label
           style={{
            fontSize: "20px",
            color: "#000",
            fontWeight: "bold",
           }}
           class="col-sm-3 col-form-label"
          >
           ژمارەی موڵك :
          </label>
          <div
           class="col-sm-3 d-flex justify-content-start"
           style={{ fontSize: "20px", fontWeight: "bold" }}
          >
           {create_asaysh.NoOfPropert}
          </div>
         </div>{" "}
         <hr
          style={{
           height: "2px",
           backgroundColor: `#000`,
          }}
         />
         {/* New One  */}
         <div
          class="form-group row form-inline"
          style={{ width: "100%", position: "fixed", bottom: 180 }}
         >
          <div className="col-1"></div>
          <label
           style={{
            fontSize: "20px",
            color: "#000",
            fontWeight: "bold",
           }}
           class="col-sm-5 col-form-label d-flex justify-content-start"
          >
           مۆر و واژووی بنکە
          </label>
          <label
           style={{
            fontSize: "20px",
            color: "#000",
            fontWeight: "bold",
           }}
           class="col-sm-5 col-form-label  d-flex justify-content-end"
          >
           مۆر و واژووی عقارات
          </label>
          <div className="col-1"></div>
         </div>
         {/* Thisrd */}
         <br />
        </div>
       </div>
      </div>
     </div>
    </div>
    {/* footer */}
    <div
     className="row"
     style={{
      position: "fixed",
      bottom: 47,
      width: "100%",
     }}
    >
     <div className="col-8 d-flex justify-content-end">
      <label
       style={{
        fontSize: 22,
        color: "#000",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
       }}
       className="fk"
      >
       {create_asaysh.branchId ? create_asaysh.branchId.adress : ""}
       &nbsp;&nbsp;
       <FaMapMarkerAlt
        style={{
         color: "#fff",
         background: " #000",
         padding: 5,
         fontSize: 25,
        }}
       />
      </label>
     </div>
     <div className="col-4 d-flex justify-content-end">
      <h4
       style={{
        fontSize: 21,
        color: "#black",
        letterSpacing: 2,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        direction: "ltr",
        lineHeight: 1.5,
       }}
      >
       <FaPhoneAlt
        style={{
         color: "#fff",
         background: " #000",
         padding: 5,
         fontSize: 25,
         marginRight: 20,
        }}
       />
       {create_asaysh.branchId ? create_asaysh.branchId.adressNumber1 : ""}{" "}
       <br />{" "}
       {create_asaysh.branchId ? create_asaysh.branchId.adressNumber2 : ""}
      </h4>
     </div>
    </div>
    <div
     style={{
      position: "fixed",
      bottom: 0,
      width: "100%",
      zIndex: -1,
     }}
    >
     <img src={footer_logo} alt="logo" width="100%" />
    </div>
   </>
  );
 }
}
const mapStateToProps = (state) => {
 return {
  lang: state.HelperReducer.lang,
  create_asaysh: state.Invoice_Reducer.create_asaysh,
  primary_logo: state.HelperReducer.primary_logo,
  primarycolor: state.HelperReducer.primarycolor,
  secondarycolor: state.HelperReducer.secondarycolor,
  logo: state.HelperReducer.logo,
  name_krd: state.HelperReducer.name_krd,
  name_arb: state.HelperReducer.name_arb,
  name_en: state.HelperReducer.name_en,
  footer_logo: state.HelperReducer.footer_logo,
 };
};

const mapDispatchToProps = (dispatch) => {
 return {
  change_Lang: (key) => dispatch(change_Lang(key)),
 };
};
export default connect(mapStateToProps, mapDispatchToProps)(PrintAsaysh);
